import React from "react";
import { connect } from "react-redux";
import { compose } from "recompose";

import { Button, FontIcon } from "react-md";

import RequestTable from "./requests/RequestTable";
import Translate from "../Atollon/Translation";
import {
    TouchNumber,
    TouchTableHeader
} from "../AtollonTheme/ReactElements";

const RequestMe_and_RequestsOther = ({ history, requestsMe, requestsOther }) => {


    let buttonWrapStyle = {textAlign: 'right', padding: '30px 0 16px 0'};
  return (
    <div className="flex-row main-tables">
      <div className="main-table">

          <TouchTableHeader
              title={"Čeká na mě"}
              titleNumber={requestsMe ? requestsMe.count : 0}
              titleButtons={(
                  <Button
                      raised
                      className="btn btn-primary touchButton-4 touchButton-shape3"
                      label={Translate( 'request-received', "Zadat přijatý požadavek" )}
                      onClick={() => history.push( "/request-received" )}
                  >
                  </Button>
              )}
          />

        <RequestTable
          history={history}
          requests={requestsMe}
          main
          forMe
        />
      </div>
      <div className="main-table">

          <TouchTableHeader
              title={"Čeká na ostatní"}
              titleNumber={requestsOther ? requestsOther.count : 0}
              titleButtons={(
                  <Button
                      raised
                      className="btn btn-primary touchButton-4 touchButton-shape3"
                      label={Translate('request-new', "Nový požadavek")}
                      onClick={() => history.push( "/request-new" )}
                  >
                  </Button>
              )}
          />

        <RequestTable
          history={history}
          requests={requestsOther}
          main
        />
      </div>
    </div>
  );
};

export default compose(
  connect(
    ({ request: { requestsMe, requestsOther } }) => ({
      requestsMe,
      requestsOther
    }),
    null
  )
)(RequestMe_and_RequestsOther);



// WEBPACK FOOTER //
// ./src/components/RequestMe_and_RequestsOther.js